<template>
    <div>
        <div v-if="trip">
            <!--<div v-show="trip.frontState !== TRIP_STATE.ARRIVED_TO_DESTINATION"  class="float-container--bottom">
                <button class="btn btn-primary btn-lg btn-heavy " v-lang.finalizarViaje @click="OnArriveToDestination">Finalizar viaje</button>
            </div>--><!-- v-show="trip.frontState === TRIP_STATE.ARRIVED_TO_DESTINATION" -->
            <div class="float-container--bottom card" v-if="!(qr && qr.message && trip.pago_electronico) || (trip.is_qr_payed > 0 && trip.pago_electronico)">
                <div :class=" this.settings.modulo_foto_pasajero ? 'col-xs-19' : ''">
                    <div class="trip-address-row">
                        <div class="trip-address">
                        <svg-item :size="24" :icon="'gps'" :color="'--card-origin-title'"></svg-item>
                        <span class="trip-address-element">{{ trip.calle }} <span v-if="trip.altura >= 0"> {{ trip.altura }}
                            </span></span>
                        </div>
                    </div>
                    <div class="trip-destination-row" v-if="settings.modulo_destino_viaje && trip.dest_nombre">
                        <svg-item :size="24" :icon="'lugar'" :color="'--card-destination-title'"></svg-item>
                        <span class="trip-destination-content">{{ trip.dest_nombre }}</span>
                        <div>
                            <button class="navigation-icon"
                                v-if="trip.frontState !== TRIP_STATE.ARRIVED_TO_DESTINATION && settings.mostrar_googlemaps_link"
                                @click="onOpenInMap(true, true, $event)">
                                <svg-item :size="30" :icon="'googlemaps'"></svg-item>
                            </button>
                            <button class="navigation-icon"
                                v-if="trip.frontState !== TRIP_STATE.ARRIVED_TO_DESTINATION && settings.mostrar_waze_link"
                                @click="onOpenInMap(true, false, $event)">
                                <svg-item :size="30" :icon="'waze'"></svg-item>
                            </button>
                        </div>
                    </div>
                    <div class="price-input" v-if="(trip.precio < 0 || settings.modulo_chofer_carga_importe) && trip.frontState === TRIP_STATE.ARRIVED_TO_DESTINATION">
                        <label v-lang.ingreseImporte for="trip_price" class="price-label">Ingrese el importe</label>
                        <div class="form-input-with-icon--wrapper">
                            <span class="form-label">
                                <svg-item :size="32" :icon="'money'" :color="'--text-color'"></svg-item>
                            </span>
                            <input class="form-input" type="text" v-model="price" id="trip_price" />
                        </div>
                    </div>
                    <div v-if="settings.modulos_pagos_en_la_app && trip.payment_method_id > 0" class="passenger-row">
                        <span v-if="trip.payment_method_id > 1">
                            <svg-item :size="24" :icon="'credit-card'" :color="'--alert-color'"></svg-item>
                            <span class="text-alert" v-lang.pagoElectronico>Pago electrónico</span>
                        </span>
                        <span v-else>
                            <svg-item :size="24" :icon="'money'" :color="'--alert-color'"></svg-item>
                            <span class="text-alert" v-lang.efectivo>Efectivo</span>
                        </span>
                    </div>
                    <div v-if="settings.modulo_precio_viaje && trip.precio > 0" class="price-show">
                        <span class="price-show-label">
                            {{ !settings.precio_final ? this.translate('precioEstimado') : this.translate('precioFinal') }}
                        </span>
                        <span class="price-show-value">
                            <span v-lang.precioPrefijo></span>
                            {{ trip.precio | numberFormatter }}
                            <span v-lang.precioSufijo></span>
                        </span>
                    </div>
                    <div v-if="metadata">
                        <span v-lang.recorrido>Recorrido</span>: <strong> {{ (metadata ? metadata.distanceValue / 1000 : 0 ) | distanceConverter(settings.medidas_en_millas) | distanceFormatter(settings.medidas_en_millas, 'big')}} </strong>
                    </div>
                </div>
                <div class="col-xs-5 passenger-img" style="float: right;" v-if="trip.chofer && this.settings.modulo_foto_pasajero">
                    <img v-imgSrc="profilePic" class="passenger-profile-photo" />
                </div>
                <div v-show="trip.frontState === TRIP_STATE.ARRIVED_TO_DESTINATION && settings.modulo_calificacion_general_pasajero">
                    <div>
                        <div class="rate-passenger-title">
                            <strong v-lang.comoCalificariaPasajero>Calificar pasajero</strong>:
                            <span>{{ trip.pasajero.nombre }} {{ trip.pasajero.apellido }}</span>
                        </div>
                        <div class="stars-widget">
                            <button v-for="star in stars" @click="makeQualification(star)" class="btn-qualify col-xs-4_8" :aria-label="'Calificar con ' + star + ' estrellas'">
                                <svg-item :icon="'star'" :color="star <= calificacion ? '--star-filled-background' : '--star-empty-background'"></svg-item>
                            </button>
                        </div>
                    </div>
                </div>
                <p v-if="trip.is_qr_payed > 0 && trip.pago_electronico" class="text-center">
                    <strong class="text-success" style="font-size: 1.2em; color: green;">Pago realizado con éxito</strong>
                </p>
                <div v-show="canAdvanceReservation && trip.frontState !== TRIP_STATE.ARRIVED_TO_DESTINATION">
                    <button class="btn btn-primary btn-lg btn-heavy " v-lang.finalizarViaje @click="OnArriveToDestination">Finalizar viaje</button>
                </div>
                <div v-show="canAdvanceReservation && trip.frontState === TRIP_STATE.ARRIVED_TO_DESTINATION">
                    <button class="btn btn-primary btn-lg btn-heavy " v-lang.registrarViaje @click="OnRecordTrip">Registrar viaje</button>
                </div>
            </div>
            <div class="float-container--bottom card" v-if="qr && qr.message && !(trip.is_qr_payed > 0) && trip.pago_electronico">
                <div v-if="settings.modulo_precio_viaje && trip.precio > 0" class="price-show">
                    <span class="price-show-label">
                        {{ this.translate('precioFinal') }}
                    </span>
                    <span class="price-show-value">
                        <span v-lang.precioPrefijo></span>
                        {{ trip.precio | numberFormatter }}
                        <span v-lang.precioSufijo></span>
                    </span>
                </div>
                <img v-if="qr" :src="qr.message" class="" style="width: 60vw; height: auto; display: block; margin: auto;" />
                <small>Esperando el pago para continuar</small>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dialogs from '@/services/dialogs.js';
import { reservationAdvanceAllowed } from '@/services/reservation';
import browser from '@/cordova/InAppBrowser';
let defaultProfilePic = require('@/assets/img/default.jpg');

export default {
    name: 'driverOnTrip',
    props: [
    ],
    data () {
        return {
            calificacion: 0,
            stars: [1, 2, 3, 4, 5],
            price: '',
            profilePic: null,
            qr: null,
            qrPollingInterval: null
        };
    },
    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            trip: 'driver/actualTrip',
            currentPosition: 'geolocation/actual',
            metadata: 'driver/actualTripMetadata',
            settings: 'company/config'
        }),
        canAdvanceReservation () {
            return reservationAdvanceAllowed(this.trip, this.settings);
        }
    },
    mounted () {
        this.language = this.$getLang();
        this.profilePic = this.trip.pasajero.photo ? this.$profile(this.trip.pasajero.photo) : defaultProfilePic;
    },
    beforeDestroy () {
        // Clean up polling interval when component is destroyed
        this.stopQrPaymentPolling();
    },

    methods: {
        ...mapActions({
            arrivedToDestination: 'driver/arrivedToDestination',
            recordTrip: 'driver/recordTrip',
            checkState: 'driver/checkState'
        }),
        OnArriveToDestination () {
            this.arrivedToDestination().then((data) => {
                console.log('OnArriveToDestination', data);
                this.qr = data;

                // Only start QR payment polling if this is an electronic payment trip
                if (this.trip && this.trip.pago_electronico) {
                    // Start polling for QR payment status
                    this.startQrPaymentPolling();
                }

                /*
                {
                    "success": true,
                    "message": "https:\/\/bcloud-pro-functionapp01.azurewebsites.net\/api\/qr\/?code=00020101021241530015ar.com.paycloud010355102020198113069226478599020150150011203306942555126002200002471000000000154715204739953030325802AR5914PABLOLUISBOTTA6007CORDOBA610450006304497B",
                    "code": ""
                }
                */
            });
        },
        startQrPaymentPolling () {
            // Clear any existing interval
            this.stopQrPaymentPolling();

            // Start polling every 5 seconds
            this.qrPollingInterval = setInterval(() => {
                // Check if QR payment is completed
                if (this.trip && this.trip.is_qr_payed === 1) {
                    console.log('QR payment completed, stopping polling');
                    this.stopQrPaymentPolling();
                    return;
                }

                // Call checkState to get updated trip status
                this.checkState().catch(error => {
                    console.error('Error checking state during QR polling:', error);
                });
            }, 5000);
        },
        stopQrPaymentPolling () {
            if (this.qrPollingInterval) {
                clearInterval(this.qrPollingInterval);
                this.qrPollingInterval = null;
            }
        },
        OnRecordTrip () {
            let data = {
                lat: this.currentPosition ? this.currentPosition.lat : 0,
                lng: this.currentPosition ? this.currentPosition.lng : 0,
                km: this.metadata ? parseFloat(this.metadata.distance) : '',
                precio: this.price ? this.price : null
            };
            if (this.settings.modulo_calificacion_general_pasajero) {
                if (this.calificacion > 0) {
                    data['calificacion_pasajero'] = this.calificacion;
                } else {
                    dialogs.message(this.translate('debeCalificarPasajero'), { duration: 3, estado: 'error' });
                    return;
                }
            }
            this.recordTrip(data);
        },
        onOpenInMap (isDestination, inGoogleMaps) {
            browser.openInMap(this.trip, isDestination, inGoogleMaps);
        },
        makeQualification (index) {
            this.calificacion = index;
        }
    }
};
</script>

<style scoped>
.form-input-with-icon--wrapper .form-input {
    font-size: 1.2em;
}
.price-label {
    color: blue;
    font-weight: normal;
    display: block;
    margin: 1em 0 .4em;
}
.rate-passenger-title {
    margin-top: 1.2rem;
    margin-bottom: .65rem;
}
.trip-address-row,
.trip-destination-row {
    padding: 2px 4px;
    font-weight: bold;
}
.trip-address-row {
    color: var(--card-origin-title);
}
.trip-destination-row {
    color: var(--card-destination-title);
}
.navigation-icon {
    margin-top: -3px;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/driver/OnFinishingTrip.vue